/* @flow */

import React from 'react';
import NavigationLinks from './components/NavigationLinks';
import type { NavigationContentLink } from 'catalog/plugins/nav/simple';

type Props = {
  content: CatalogPageContent,
  onSerialize?: (content: CatalogPageContent) => void,
};

const Edit = ({ content, onSerialize }: Props) => {
  const linkAdded = (link: NavigationContentLink) =>
    onSerialize({
      ...content,
      items: [...content.items, link],
    });

  const linksUpdated = (updated: Array<NavigationContentLink>) =>
    onSerialize({
      ...content,
      items: updated,
    });

  return (
    <div>
      <NavigationLinks
        layout={content.layout}
        links={content.items}
        resourceStrategy={content.layout.strategy}
        onAdd={linkAdded}
        onUpdate={linksUpdated}
      />
    </div>
  );
};

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/nav/simple/Edit.js